document.addEventListener('DOMContentLoaded', function () {
  showSelectedVariant();
});

/**
 * getVariantIndex
 *  @returns {Number}
 */
export function getVariantIndex() {
  const paramString = window.location.search;
  if (!paramString) return 0;
  const urlParams = new URLSearchParams(paramString);
  const variant = urlParams.get('variant');
  if (!variant) return 0;

  /** @type {HTMLElement | null} */
  const variantImage = document.querySelector(`.product__media [data-variant-ids*="${variant}"]`);
  return variantImage?.dataset?.index || 0;
}

/**
 * Navigate to variant image
 * @param {String | null | undefined} [variantId] - fired in variant-selector.js
 */
export function showSelectedVariant() {
  let variantId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
  // Get from URL
  if (!variantId) {
    const paramString = window.location.search;
    if (paramString) {
      const urlParams = new URLSearchParams(paramString);
      variantId = urlParams.get('variant') || undefined;
    }
  }

  // Fall back to initial variant
  if (!variantId) {
    const productWrapper = document.querySelector('.product__wrapper[data-initial-variant]');
    if (productWrapper instanceof HTMLElement) {
      variantId = productWrapper.dataset.initialVariant;
    }
  }
  if (!variantId) return;
  const isTieredLayout = document.querySelector('.product__media .vertical-scroll-tiered') !== undefined;

  /** @type {NodeListOf<HTMLElement>} */
  const pdpMediaItems = document.querySelectorAll('.product__media .carousel-wrapper [data-pdp-media-item]');

  /** @type {NodeListOf<HTMLElement>} */
  const variantItems = document.querySelectorAll(`.product__media .carousel-wrapper [data-variant-id="${variantId}"]`);
  if (variantItems) {
    pdpMediaItems.forEach(item => {
      item.style.order = '';
      item.classList.remove('col-span-2');
    });
    variantItems.forEach((item, index) => {
      if (index === 0 && isTieredLayout) {
        item.classList.add('col-span-2');
      }
      item.style.order = -999 + index;
    });
  }
}